import { ReactNode } from "react";
import { Button, Card, Form } from "react-bootstrap";
import FormFieldLabel from "@components/Forms/FormFieldLabel/FormFieldLabel";
import SearchField from "@components/Forms/SearchField/SearchField";
import { BatchActionPill, BatchAction } from "./BatchActionPill";
import "./CatalogIndex.css";

export interface AdminListCardSearchProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onClear: () => void;
  label?: string;
}

export interface AdminListCardSecondaryAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface AdminListCardProps {
  title: string;
  onNew?: () => void;
  newButtonLabel?: string;
  secondaryAction?: AdminListCardSecondaryAction;
  searchProps?: AdminListCardSearchProps;
  batchActions?: BatchAction[];
  selectedCount?: number;
  children: ReactNode;
}

export const AdminListCard = ({
  title,
  onNew,
  newButtonLabel = "+ New",
  secondaryAction,
  searchProps,
  batchActions,
  selectedCount = 0,
  children,
}: AdminListCardProps) => {
  const showBatchPill =
    !!batchActions && batchActions.length > 0 && selectedCount > 0;
  const showActionRow = showBatchPill || !!searchProps;

  return (
    <div className="admin-list-card legacyPageBleed">
      <Card>
        <Card.Header>
          <div className="admin-list-card__title-row">
            <div className="adminListCardTitle">{title}</div>
            <div className="admin-list-card__title-actions">
              {secondaryAction && (
                <Button
                  className="btnSeawhite"
                  onClick={secondaryAction.onClick}
                  disabled={secondaryAction.disabled}
                >
                  {secondaryAction.label}
                </Button>
              )}
              {onNew && (
                <Button className="squareGreenButton" onClick={onNew}>
                  {newButtonLabel}
                </Button>
              )}
            </div>
          </div>
          <hr />
          {showActionRow && (
            <div className="admin-list-card__action-row">
              {showBatchPill && (
                <BatchActionPill
                  selectedCount={selectedCount}
                  actions={batchActions!}
                />
              )}
              {searchProps && (
                <div className="admin-list-card__search-wrapper">
                  <FormFieldLabel
                    label={searchProps.label ?? "Search"}
                    className={undefined as unknown as string}
                  />
                  <Form
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        searchProps.onSubmit(
                          e as unknown as React.FormEvent<HTMLFormElement>
                        );
                      }
                    }}
                    onSubmit={searchProps.onSubmit}
                  >
                    <SearchField
                      placeholder={searchProps.placeholder}
                      value={searchProps.value}
                      onChange={searchProps.onChange}
                      onClick={searchProps.onClear}
                      fullWidth
                    />
                  </Form>
                </div>
              )}
            </div>
          )}
        </Card.Header>
        {children}
      </Card>
    </div>
  );
};
